
import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { ReactNode } from "react";
import { matchPath } from "react-router-dom";
interface AppProviderType{
    isLoading: boolean,
    authToken: string | null,
    login: (email: string, password: string) => Promise<void>,
    register: (name: string, email: string, password: string, password_confirmation: string) => Promise<void>,
    logout: () => Promise<void>
}

export const AppContext = createContext<AppProviderType|undefined>(undefined)

const API_URL = process.env.REACT_APP_API_URL;

export const AppProvider = ({ children }: { children: ReactNode }) => {
            const [isLoading, setIsLoading] = useState<boolean>(false)
            const [authToken, setAuthToken] = useState<string|null>(null)
            const navigate = useNavigate()
            const isRouteMatch = (routes: string[], pathname: string) => {
                return routes.some(route =>
                matchPath({ path: route, end: true }, pathname)
                );
            };
            const publicRoutes = ["/", "/troypus", "/kaipedia", "/kaipedia/:id", "/showcase", "/catcase", "/dogcase", "/showcase/chess", "/showcase/katz"];
            const protectedRoutes = ["/dashboard", "/project", "/skill", "/articles"];

            useEffect(() => {
                const token = Cookies.get("authToken");
                const currentPath = window.location.pathname;
                const isPublic = isRouteMatch(publicRoutes, currentPath);
                const isProtected = isRouteMatch(protectedRoutes, currentPath);
                if (token) {
                    setAuthToken(token);
                    if (!isPublic && !isProtected) {
                        navigate("/not-found", { replace: true });
                    }
                } else {
                    if (isProtected) {
                    navigate("/troypus", { replace: true });
                    } else if (!isPublic) {
                    navigate("/not-found", { replace: true });
                    }
                }
                setIsLoading(false);
            }, []);
            

            const login = async(email: string, password: string) => {
                setIsLoading(true)
                try {
                    const response = await axios.post(`${API_URL}/login`, {
                        email,
                        password
                    });
                    const status = JSON.parse(response.data.status);

                    if(status){
                        Cookies.set("authToken", response.data.token, {expires: 1})
                        toast.success('Login successfull');
                        setAuthToken(response.data.token)
                        navigate("/dashboard")
                    } else {
                        toast.error(response.data.message);
                    }

                } catch (error) {
                    toast.error('Login failed. Please try again.');
                } finally {
                    setIsLoading(false)
                }
            }

            const register = async(name: string, email: string, password: string, password_confirmation: string) => {
                setIsLoading(true)
                try {
                    const response = await axios.post(`${API_URL}/register`, {
                        name,
                        email,
                        password,
                        password_confirmation
                    });

                    console.log(response)
                } catch (error) {
                    toast.error('Register failed. Please try again.');
                } finally {
                    setIsLoading(false)
                }
            }
            const logout = async() => {
                setAuthToken(null);
                Cookies.remove("authToken");
                navigate("/troypus");
                toast.success('User Logout');
                setIsLoading(false);
            }

            return (
                <AppContext.Provider value={{login, register, logout, isLoading, authToken}}>
                    {isLoading ? (
                        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
                            <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
                        </div>
                    ) : children}
                </AppContext.Provider>
            )
        }

        export const useAppContext = () => {
            const context = useContext(AppContext);
            if (!context) {
                throw new Error("Context must be wrapped inside AppProvider");
            }
            return context; 
        };
        